var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H7.5C6.67157 6 6 6.67157 6 7.5V18.5C6 19.3284 6.67157 20 7.5 20H14.5C15.3284 20 16 19.3284 16 18.5V7.5C16 6.67157 15.3284 6 14.5 6Z",
    fill: "#6F9FE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.064 5.064C8.20539 5.02132 8.3523 4.99975 8.5 5H15.5C15.8978 5 16.2794 5.15804 16.5607 5.43934C16.842 5.72064 17 6.10218 17 6.5V17.5C17.0002 17.6477 16.9787 17.7946 16.936 17.936C17.2439 17.8425 17.5136 17.6523 17.7052 17.3938C17.8968 17.1352 18.0002 16.8218 18 16.5V5.5C18 5.10218 17.842 4.72064 17.5607 4.43934C17.2794 4.15804 16.8978 4 16.5 4H9.5C9.17816 3.99984 8.86481 4.10319 8.60623 4.29478C8.34765 4.48638 8.15754 4.75606 8.064 5.064Z",
    fill: "#6F9FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.91f27c21.svg";
export { ForwardRef as ReactComponent };